import { useEffect, useMemo } from "react";

import { useDebouncedValue } from "@mantine/hooks";
import { useQuery } from "@tanstack/react-query";

import type { AssertRecord } from "@/common/utils/AssertRecord";
import type { UseFormReturnTypeStrict } from "@/common/utils/UseFormReturnTypeStrict";
import { getActionQueryOptions } from "./getActionQueryOptions";

import type { ActionInput, ActionName } from "@/setup/backend/types";
export function useActionFormValidate<A extends ActionName>(
	name: A,
	form: Pick<
		UseFormReturnTypeStrict<AssertRecord<ActionInput<A>>>,
		| "values"
		| "setFieldError"
		| "clearFieldError"
		| "getTransformedValues"
		| "setErrors"
	>,
) {
	const transformedValues = useMemo(
		() => form.getTransformedValues(form.values),
		[form.values],
	);
	const [debouncedValues] = useDebouncedValue(transformedValues, 500, {
		leading: false,
	});
	const parseOnlyQuery = useQuery({
		...getActionQueryOptions(name, debouncedValues, {
			parseOnly: true,
		}),
	});

	useEffect(() => {
		if (parseOnlyQuery.data) {
			form.setErrors((parseOnlyQuery.data ?? {}) as any);
		}
	}, [parseOnlyQuery.data]);

	return parseOnlyQuery;
}
